import formatDate from '@/services/general/formatIsoDate';

export default function preparationEnvoieAuBackAudit(audit) {
  audit.dateSouhaitee = formatDate(audit.dateSouhaitee);
  audit.datePlanification = formatDate(audit.datePlanification);
  audit.dateRealisation = formatDate(audit.dateRealisation);
  audit.montantHt = audit.montantHt ?? 0;
  audit.otPatrimoine.otsAuditEnfants.forEach((ot) => {
    ot.dateSouhaitee = audit.dateSouhaitee;
    ot.typeOtId = audit.typeOtId;
    ot.agenceId = audit.agenceId;
    ot.societeId = audit.societeId;
    delete ot.dateRealisation;
  });
  return audit;
}
